import { render, staticRenderFns } from "./objecttives.vue?vue&type=template&id=8e1620ce&"
import script from "./objecttives.vue?vue&type=script&lang=js&"
export * from "./objecttives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports